import { Component, OnInit, Input } from '@angular/core';
import { ReservationStore } from '../../service/reservation-store';
import { RoomTypeRateSummary } from '../../models/room-type-rate-summary';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { OVERVIEW_STATUS_CODES } from '../../models/reservation-status-code.enum';
import { RoomStaySummary } from '../../models/room-stay-summary';
import { OnyxEvent } from '../../models/event';
import { RsvpStore } from '../../service/rsvp.store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';

@Component({
  selector: 'pioneer-stay-summary',
  templateUrl: './stay-summary.component.html'
})
export class StaySummaryComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public recordType: SummaryRecordTypeEnum;

  public roomTypeRateSummaryList: Observable<List<RoomTypeRateSummary>>;

  constructor(private reservationStore: ReservationStore,
              private rsvpStore: RsvpStore) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input('type')
  set type(type: SummaryRecordTypeEnum) {
    this.recordType = type;
  }

  ngOnInit() {
    if (this.recordType === SummaryRecordTypeEnum.RESERVATION) {
      this.roomTypeRateSummaryList = this.reservationStore.getRoomStaySummaryFilteredByStatus(OVERVIEW_STATUS_CODES)
        .map((roomStaySummary: RoomStaySummary) => {
          return roomStaySummary.roomTypeRateSummaryList;
        });
    } else if (this.recordType === SummaryRecordTypeEnum.RSVP) {
      this.roomTypeRateSummaryList = this.rsvpStore.getRoomStaySummary()
        .map((roomStaySummary: RoomStaySummary) => {
          return roomStaySummary.roomTypeRateSummaryList;
        });
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/overview/stay-summary/stay-summary.component.ts